<template>
  <div class="logDetail">
    <div class="top_steps">
      <span class="click_point" @click="goToIndex">{{TLang('演出首页','my')}}</span>
      <span class="top_arrow_icon">
        <img :src="staticAssets.ImgObj.arrow_right" alt />
      </span>
      <span class="click_point" @click="goToList">{{TLang('演出订单','my')}}</span>
      <span class="top_arrow_icon">
        <img :src="staticAssets.ImgObj.arrow_right" alt />
      </span>
      <span class="click_point" @click="back">{{TLang('订单详情','list')}}</span>
      <span class="top_arrow_icon">
        <img :src="staticAssets.ImgObj.arrow_right" alt />
      </span>
      <span>{{TLang('物流详情','my')}}</span>
    </div>
    <div class="log_wrap" v-if="deliveryStatus && !isloading">
      <div>
        <span class="c9">{{TLang('快递方式','my')}}</span>
        <span>{{TLang('普通配送','my')}}</span>
      </div>
      <div class="row_sec">
        <div class="logNum">
          <span class="c9">{{TLang('快递编号','home')}}</span>
          <span>{{ result.waybillNo }}</span>
        </div>
        <div class="logcom">
          <span class="c9">{{TLang('快递公司','my')}}</span>
          <span>{{ result.deliveryCompanyName }}</span>
        </div>
      </div>
      <div class="fenge"></div>

      <div class="bottom_show">
        <div v-for="(item, index) in data" :key="index">
          <div class="line" v-if="index == data.length - 1 && index != 0">
            <div class="line_left">
              <div :class="{ shu: true, top_shu: true }"></div>
              <div
                :class="{
                  quan: true,
                  top_quan: true,
                  over: deliveryStatus == 2
                }"
              ></div>
            </div>
            <div class="line-right">
              {{ item.time }} <span class="rightEvent">{{ item.event }} </span>
            </div>
          </div>
        </div>

        <div v-for="(item, index) in data" :key="'in' + index">
          <div class="line" v-if="index !== 0 && index != data.length - 1">
            <div class="line_left">
              <div class="shu"></div>
              <div class="quan"></div>
            </div>
            <div class="line-right">
              {{ item.time }} <span class="rightEvent">{{ item.event }} </span>
            </div>
          </div>
        </div>
        <!-- 最底部展示 -->
        <div v-for="(item, index) in data" :key="'ins' + index">
          <div class="line" v-if="index == 0 && data.length > 1">
            <div class="line_left">
              <div class="shu bottom_shu"></div>
              <div class="quan"></div>
            </div>
            <div class="line-right">
              {{ item.time }} <span class="rightEvent">{{ item.event }} </span>
            </div>
          </div>
        </div>

        <!-- 只有一条数据展示 -->
        <div>
          <div class="line" v-if="data.length == 1">
            <div class="line_left">
              <div class="quan top_quan"></div>
            </div>
            <div class="line-right">
              {{ data[0].time }}
              <span class="rightEvent">{{ data[0].event }} </span>
            </div>
          </div>
        </div>

        <!-- 无数据展示 -->
        <div v-if="data.length == 0">{{TLang('抱歉暂无数据','my')}}</div>
      </div>
    </div>
    <div class="nodata" v-if="!deliveryStatus && !isloading">
      <img :src="staticAssets.ImgObj.no_data_img" alt="" />
      <div class="nodata_font">{{TLang('演出票未发货您耐心等待','my')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "logStics",
  data() {
    return {
      data: [],
      deliveryStatus: "", // 0 未发货 1已发货 2已签收
      result: {}, //物流详情信息
      isloading: true
    };
  },
  created() {
    this.isloading = true;
    this.apis.showOrder
      .getLogDetail({
        orderNo: this.$route.query.orderNo
      })
      .then(res => {
        this.isloading = false;
        this.result = res.body;
        this.deliveryStatus = res.body.deliveryStatus;
        this.data = res.body.deliverySchedule || [];
      });
  },
  methods: {
    goToIndex() {
      this.$router.push({
        path: "/"
      });
    },
    goToList() {
      this.$router.push({
        path: !this.$route.query.union
          ? "/order/list"
          : "/order/unionorderlist",
        query: !this.$route.query.union
          ? {
              city: this.$route.query.city
            }
          : {
              city: this.$route.query.city,
              union: this.$route.query.union
            }
      });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="less">
.rightEvent {
  margin-left: 20px;
}
.bottom_show {
  .clearfix;
  padding-top: 24px;
}
.line {
  line-height: 31px;
  .clearfix;
}
.line_left {
  width: 10px;
  height: 31px;
  margin-right: 20px;
  position: relative;
  float: left;
}
.line-right {
  float: left;
}
.shu {
  width: 1px;
  height: 31px;
  position: absolute;
  top: 0;
  left: 5px;
  background-color: #e5e5e5;
}
.top_shu {
  height: 16px;
  top: 15px;
}

.bottom_shu {
  height: 15px;
}
.quan {
  width: 7px;
  height: 7px;
  border-radius: 4px;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  position: absolute;
  top: 13px;
  left: 2px;
  background-color: white;
}
.top_quan {
  border: 4px solid #3d96e2;
  width: 11px;
  height: 11px;
  border-radius: 6px;
  top: 10px;
  left: 0;
}
.left {
  float: left;
  height: 100%;
  width: 10px;
  position: relative;
}
.shuline {
  position: absolute;
  top: 0;
  left: 4px;
  height: 100%;
  background-color: black;
}
.right {
  float: left;
  height: 200px;
}
.c9 {
  color: #999999;
}
.logNum,
.logcom {
  float: left;
}
.logcom {
  margin-left: 32px;
}
.over {
  border: none;
  background: url("../../assets/imgs/over.png");
  background-size: 100% 100%;
  left: -2px;
  width: 15px;
  height: 15px;
}
.row_sec {
  .clearfix;
  margin-top: 8px;
  line-height: 19px;
}
.log_wrap {
  width: 100%;
  border: 1px solid rgba(229, 229, 229, 1);
  padding: 24px;
  font-size: 14px;
  min-height: 350px;
}
.fenge {
  margin-top: 16px;
  height: 1px;
  background-color: #e5e5e5;
}
.logDetail {
  width: 1200px;
  margin: 0 auto;
}
.top_steps {
  margin: 16px 0;
  .click_point {
    cursor: pointer;
  }
  span {
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    line-height: 16px;
    display: inline-block;
  }

  .top_arrow_icon img {
    .drama_specs_unit(12px, 12px);
    margin: 2px 4px;
  }
}
.nodata {
  text-align: center;
}
.nodata img {
  width: 650px;
  margin: 82px auto;
  margin-bottom: 20px;
}
.nodata_font {
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  color: #999999;
}
</style>
